import React from "react";
import Swal from "sweetalert2";

export default function ShippedButton({ orderId, onShipped }) {
  const handleShippedClick = () => {
    Swal.fire({
      title: `<h4>Are you sure you want to mark this order as shipped?</h4>`,
      text: "Once confirmed, the status will be updated!",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, mark as shipped!",
      customClass: {
        title: "swal-custom-title",
        icon: "swal-custom-icon",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        onShipped(orderId);
      }
    });
  };

  return (
    <button
      className="confirm-button btn btn-success mt-5"
      onClick={(e) => {
        e.preventDefault(); // Prevent page reload
        handleShippedClick();
      }}
    >
      SHIPPED
    </button>
  );
}
